module.exports = __webpack_public_path__ + "bad-bramstedt.jpg?42a1ffdad0831493c379de82ee402e20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bad-bramstedt.jpg
// module id = 379
// module chunks = 0